import React, { createContext, useContext, useState, useEffect } from 'react';
import { getPackageMetrics } from '../utils/statsService';
import { firebaseStargazersService } from '../services/firebaseStargazers';

const StatsContext = createContext();

export const useStats = () => {
  const context = useContext(StatsContext);
  if (!context) {
    throw new Error('useStats must be used within a StatsProvider');
  }
  return context;
};

export const StatsProvider = ({ children }) => {
  const [packageStats, setPackageStats] = useState({
    likes: '0',
    weeklyDownloads: '0',
    totalDownloads: '0',
    pubPoints: 0,
    popularity: 0
  });
  const [stargazersCount, setStargazersCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const [packageStats, repoStats] = await Promise.all([
          getPackageMetrics('geolocator'),
          firebaseStargazersService.getRepoStats()
        ]);

        setPackageStats(packageStats);
        setStargazersCount(repoStats.total_stargazers || 0);
      } catch (error) {
        console.error('Error fetching stats:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  const value = {
    packageStats,
    stargazersCount,
    loading
  };

  return (
    <StatsContext.Provider value={value}>
      {children}
    </StatsContext.Provider>
  );
};